import {
  EARTHQUAKE_SEARCH_CLEAR,
  EARTHQUAKE_SEARCH_REQUEST,
  EARTHQUAKE_SEARCH_CLEAR_REDIRECT,
  EARTHQUAKE_SEARCH_REGION_REQUEST,
  EARTHQUAKE_SEARCH_COUNTRY_REQUEST,
  EARTHQUAKE_SEARCH_AREA_REQUEST,
} from './earthquakeSearchReducer';

export const searchEarthquakes = ({
  queryParameters, formModel, location, searchRedirect, history,
}) => ({
  type: EARTHQUAKE_SEARCH_REQUEST, queryParameters, formModel, location, searchRedirect, history,
});
export const clearEarthquakeSearch = () => ({ type: EARTHQUAKE_SEARCH_CLEAR });
export const clearRedirect = () => ({ type: EARTHQUAKE_SEARCH_CLEAR_REDIRECT });

export const getRegions = ({ history }) => ({ type: EARTHQUAKE_SEARCH_REGION_REQUEST, history });
export const getCountries = ({ history }) => ({ type: EARTHQUAKE_SEARCH_COUNTRY_REQUEST, history });
export const getAreas = ({ country, history }) => ({ type: EARTHQUAKE_SEARCH_AREA_REQUEST, country, history });
